import React from 'react';
import { QuestionsNotification } from './types';


 const QuestionNotification = ({notification,setNotification}:QuestionsNotification) => {
    const closeNotification = () => {
        setNotification({status:'Hidden',message:''})
    }
    
    return(
        <div className="Notification">
            <div data-testid={`notification-${notification.status}`} className={`Notification__Container ${notification.status}`}>
            <span onClick={closeNotification} className="Notification__Close">x</span>
            <p className="Notification__Message">{notification.message}</p>
            </div>
        </div>
    )
}
export default QuestionNotification 